import { useEffect, useState, useRef } from 'react'

interface NotificationProps {
  storageKey: string
  message: React.ReactNode
  maxDisplays?: number
  cutoffDate?: Date
  className?: string
}

export default function Notification({
  storageKey,
  message,
  maxDisplays = 5,
  cutoffDate = new Date('2025-09-19T00:00:00Z'),
  className = 'notification-lozenge',
}: NotificationProps) {
  const [visible, setVisible] = useState(false)
  const hasRun = useRef(false) // prevents double-increment

  useEffect(() => {
    if (hasRun.current) return
    hasRun.current = true

    const now = new Date()

    if (cutoffDate && now > cutoffDate) return

    if (localStorage.getItem(`${storageKey}-dismissed`) === 'true') return

    const count = parseInt(localStorage.getItem(storageKey) || '0', 10)

    if (count < maxDisplays) {
      setVisible(true)
      localStorage.setItem(storageKey, (count + 1).toString())
    }
  }, [storageKey, maxDisplays, cutoffDate])

  const handleDismiss = () => {
    localStorage.setItem(`${storageKey}-dismissed`, 'true')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className={className}>
      <span>{message}</span>
      <span onClick={handleDismiss} className="dismiss" aria-label="Dismiss notification">
        ×
      </span>
    </div>
  )
}
